// src/pages/payments/_paymentsShared.jsx
// Helper compartido por pantallas de pagos. Equivale a FlowHeader/FlowHead/PubHead
// del mockup v4 (mismo patrón: back button + título a la derecha).
import React from 'react';

export const FlowHeader = ({ back, title }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
    {back && (
      <button
        onClick={back}
        style={{
          width: 36,
          height: 36,
          borderRadius: 10,
          background: 'var(--bg-elev)',
          border: '1px solid var(--line)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
          <path d="M15 6l-6 6 6 6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    )}
    <div style={{ fontWeight: 600, fontSize: 15 }}>{title}</div>
  </div>
);
